import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Logout } from '../../apis';
import logo from '../../assets/img/credibled_logo_205x45.png';
import AdminLayout from './AdminLayout';
import ClientAdminLayout from './ClientAdminLayout';
import UserLayout from './UserLayout';

const Layouts = ({ type, children }: any) => {
	const navigate = useNavigate();
	const currLink = useLocation().pathname;
	const baseLink = currLink.split('/')[1];
	const [userName] = useState('');

	const handleLogout = async () => {
		try {
			const resp = await Logout();
			localStorage.clear();
			if ('caches' in window) {
				console.log('hit');
				caches.keys().then(names => {
					names.forEach(name => {
						caches.delete(name);
					});
				});
			}

			navigate(`${baseLink.includes('admin') ? '/admin/login' : '/signin'}`);
			if (resp.status === 200) {
				//  console.log("Logout successfully !")
			}
		} catch (e) {
			navigate(`${baseLink.includes('admin') ? '/admin/login' : '/signin'}`);
		}
	};
	if (
		currLink === '/home/template-builder' ||
		currLink.includes('/home/template-builder')
	) {
		return children;
	}

	let renderLogout;
	if (type === 'super-admin') {
		renderLogout = (
			<li className='nav-item'>
				<button
					className='btn btn-primary mx-4 my-3'
					style={{ cursor: 'pointer' }}
					onClick={() => handleLogout()}
				>
					Log out
				</button>
			</li>
		);
	} else {
		renderLogout = (
			<li className='nav-item dropdown'>
				<a
					className='nav-link dropdown-toggle'
					href='#!'
					id='navbarDropdownMenuLink'
					data-toggle='dropdown'
					aria-haspopup='true'
					aria-expanded='false'
					role='menuitem'
				>
					<i className='material-icons'>account_box</i> Hi,{' '}
					<span className='text-secondary'>
						{localStorage.getItem('firstName')
							? localStorage.getItem('firstName')
							: userName.length > 0
							? userName
							: 'There'}
					</span>
				</a>
				<div
					className='dropdown-menu'
					aria-labelledby='navbarDropdownMenuLink'
				>
					<Link
						to={`/${baseLink}/settings`}
						className='dropdown-item'
					>
						Profile
					</Link>
					<button
						className='dropdown-item'
						style={{ cursor: 'pointer' }}
						onClick={() => handleLogout()}
					>
						Log out
					</button>
				</div>
			</li>
		);
	}

	return (
		<div className='wrapper'>
			{type === 'admin' ? <ClientAdminLayout /> : null}
			{type === 'user' ? <UserLayout /> : null}
			{type === 'super-admin' ? <AdminLayout /> : null}
			<div className='main-panel'>
				<nav
					className='navbar navbar-expand navbar-transparent navbar-absolute fixed-top mobile_logo'
					style={{ position: 'relative', top: '-10px' }}
				>
					<div className='container-fluid'>
						<div className='navbar-wrapper'>
							<div
								className='showonmobile'
								style={{ display: `none` }}
							>
								<a
									className='navbar-brand'
									href='/'
								>
									<img
										src={logo}
										alt='Credibled Logo'
										className='mob_logo'
									/>
								</a>
							</div>
						</div>
						<div className=''>
							<ul className='navbar-nav'>{renderLogout}</ul>
						</div>
					</div>
				</nav>
				<div className='content'>
					<div
						className='container-fluid'
						style={{ position: 'relative', top: '-60px' }}
					>
						{children}
					</div>
				</div>
			</div>
		</div>
	);
};
export default Layouts;
